(function () {
  const els = document.querySelectorAll('.page-nav');
  const activeNav = document.querySelector('.page-nav')

  function PageNav ($el) {
    const obj = {};

    obj.active = null;
    obj.$el = $el;
    obj.items = obj.$el.querySelectorAll('li');

    obj.anchors = [];

    for (const item of obj.items) {
      const link = item.querySelector('a[data-anchor]');

      if (!link) {
        break;
      }

      const hash = link.getAttribute('href').split('#').pop();
      if (!hash) {
        break;
      }

      link.setAttribute('data-anchor', hash);

      const anchorEl = document.getElementById(hash);
      if (!anchorEl) {
        break;
      }

      obj.anchors[hash] = anchorEl;

      link.addEventListener('click', function (ev) {
        const pos = document.getElementById(hash).getBoundingClientRect().top;
        obj.anchors[hash] = document.getElementById(hash);

        window.scrollBy({
          top: pos,
          left: 0,
          behavior: 'smooth'
        });

        ev.preventDefault();
      });
    }

    if (obj.$el.querySelector('a.active')) {
      obj.$el.scrollBy({
        top: 0,
        left:
          obj.$el.querySelector('a.active').getBoundingClientRect().left - 15
      });
    }

    obj.timeOutScroll = null;

    obj.checkScroll = function () {
      const actives = Object.keys(obj.anchors).filter((a) => {
        return obj.anchors[a].getBoundingClientRect().top <= 2;
      });

      const active = actives.length ? actives.pop() : null;

      if (!active) {
        obj.$el
          .querySelectorAll('li a[data-anchor]')
          .forEach((a) => a.classList.remove('active', 'lot-border'));
        activeNav.classList.remove('active')
      }

      if (active && active != obj.active) {
        if (obj.timeOutScroll) {
          clearTimeout(obj.timeOutScroll);
        }

        obj.$el
          .querySelectorAll('li a[data-anchor]')
          .forEach((a) => a.classList.remove('active', 'lot-border'));

        if (active) {
          obj.$el
            .querySelector('a[data-anchor="' + active + '"]')
            .classList.add('active', 'lot-border');

          activeNav.classList.add('active')
        }

        obj.timeOutScroll = setTimeout(function () {
          obj.$el.scrollBy({
            top: 0,
            left: active
              ? obj.$el
                .querySelector('a[data-anchor="' + active + '"]')
                .getBoundingClientRect().left - 15
              : 0,
            behavior: 'smooth'
          });
        }, 100);
      }
    };

    obj.checkScroll();

    window.addEventListener('scroll', obj.checkScroll);

    if (
      window.location.hash &&
      obj.anchors[window.location.hash.split('#').join('')]
    ) {
      const linkHash = $el.querySelector(
        'a[data-anchor="' + window.location.hash.split('#').join('') + '"]'
      );

      if (linkHash) {
        linkHash.click();
      }
    }

    return obj;
  }

  if (els.length) {
    document.querySelector('body').classList.add('has-page-nav');

    els.forEach((a) => (a = new PageNav(a)));
  }
})();
